/* Copyright (c) 2019-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Commands } from 'bridge-commands/commands';
import { BrowserPlugin } from 'crimson/lib/bridge/browser-plugin/browser-plugin';
import { PluginHandlers, PluginResponse } from 'crimson/lib/bridge/common/plugin.models';
import { FullBridgeCommand } from 'crimson/lib/bridge/bridge.service';

const Update = Commands.Common.Update;

@Injectable({
    providedIn: 'root'
})
export class UpdatePlugin extends BrowserPlugin {
    constructor() {
        super();
    }

    public get handlers(): PluginHandlers {
        return {
            module: Update.ReadTicket.module,
            commands: {
                [Update.ReadTicket.method]: this.readTicket.bind(this)
            }
        };
    }

    private readTicket(command: FullBridgeCommand<{}>): Observable<PluginResponse> {
        return this.makeResult('{"available":false,"severity":"","version":""}');
    }
}
